import eventemitter3 from 'eventemitter3';
import io from 'socket.io-client';
import config from './config';

const appId = config.realtimeengine;

class EventEmitter4 extends eventemitter3
{
	setSocket(socket) {
		this.socket = socket;
	}

	on(event, callback, watch) {
		if (this.socket) {
			this.socket.emit('subscribe', {app: appId, event, watch});
		}
		super.on(event, callback);
	}

	/*removeListener(event, callback) {
		if (this.socket) {
			//this.socket.emit('unsubscribe', {event, watch});
		}
		super.removeListener(event, callback);
	}*/
}

const eventEmitter = new EventEmitter4();

if (!__MOBILE__) {
	const socket = io('https://realtime-engine.reactis.cz');
	eventEmitter.setSocket(socket);
	socket.on('connect', () => {
		const init = {
			userId: 0,
			appId: appId,
			winId: Math.random()
		};
		socket.emit('init', init);
	});
	socket.on('event', (data) => {
		console.log(data);
		eventEmitter.emit(data.data.event, data.data.params);
	});
}

export default eventEmitter;


// WEBPACK FOOTER //
// ./src/EventEmitter.js